export const IfisVersion = () => {
  return (
    <>v2.1.26</>
  )
}